import { onResize } from "@js/throttle.js";

let measureDiv = null;

export default function createUnitlessVariable(fromVar, toVar, element = document.documentElement) {
	function updateValue() {
		let parentElement = element;
		let rootElement = element;

		if (element == document.documentElement) {
			parentElement = document.body;
		}

		// Reuse measuring div to avoid repeated DOM creation
		if (!measureDiv) {
			measureDiv = document.createElement('div');
			measureDiv.style.position = 'absolute';
			measureDiv.style.visibility = 'hidden';
			measureDiv.style.pointerEvents = 'none';
		}

		measureDiv.style.width = `var(${fromVar})`;
		parentElement.appendChild(measureDiv);
		const value = measureDiv.getBoundingClientRect().width;
		parentElement.removeChild(measureDiv);

		const unitlessValue = parseFloat(value);
		rootElement.style.setProperty(toVar, unitlessValue);
	}

	updateValue();

	// Use throttled resize handler
	onResize(updateValue);
}
